import React from 'react';
import googleReviews from 'assets/google-review-data.json';
import { FlexRow } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import get from 'lodash.get';
import GoogleIconSvg from 'pages/common/components/svgs/GoogleIconSvg';
import OpencareLogoPattern from 'pages/common/components/svgs/OpencareLogoPatternSvg';
import { reviewRatingMean } from 'pages/common/helpers/common-helpers';
import PropTypes from 'prop-types';

import ReviewSourceCard from '../ReviewSourceCard/ReviewSourceCard';

function ReviewSourcesBlock({ clinicId, opencareReviews }) {
  return (
    <FlexRow>
      <ReviewSourceCard
        source="Opencare"
        averageRating={reviewRatingMean(opencareReviews)}
        reviewCount={opencareReviews.length}
        borderColor="#bcdcd6"
        backgroundColor="#e0f5f1"
        headingColor={colors.sage7}
        icon={<OpencareLogoPattern color={colors.sage7} height="15px" />}
      />
      <ReviewSourceCard
        link={get(googleReviews[clinicId], 'url')}
        source="Google"
        averageRating={get(googleReviews[clinicId], 'rating')}
        reviewCount={get(googleReviews[clinicId], 'count')}
        borderColor="#cfe4fc"
        backgroundColor="#e7f1fc"
        headingColor={colors.blue}
        icon={<GoogleIconSvg height="15px" />}
      />
    </FlexRow>
  );
}

ReviewSourcesBlock.propTypes = {
  clinicId: PropTypes.number.isRequired,
  opencareReviews: PropTypes.array.isRequired,
};

export default ReviewSourcesBlock;
